import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'border-bg-items-black letter-spacing-0.02 font-regular relative ml-0 flex h-[50px] cursor-pointer items-center justify-center border px-[35.5px] py-[14px] text-base font-[380] font-light whitespace-nowrap transition',
    loading: 'loading absolute transition-opacity',
    children: 'flex-center relative transition-opacity'
  },
  variants: {
    color: {
      primary: 'text-bg-items-black bg-transparent',
      secondary:
        'bg-bg-items-black text-text-main-inversion text-button-main-inversion hover:bg-brand-400 border-0 font-normal',
      white:
        'border-button-main-inversion text-button-main-inversion bg-transparent',
      transparent:
        'text-text-inactive text-s border-0 leading-[140%] font-medium'
    },
    loading: {
      true: {
        base: 'cursor-default',
        loading: 'opacity-100',
        children: 'opacity-0'
      },
      false: {
        loading: 'opacity-0',
        children: 'opacity-100'
      }
    },
    disabled: {
      true: {
        base: 'cursor-default'
      }
    },
    rounded: {
      full: {
        base: 'rounded-full'
      }
    },
    noBorder: {
      true: {
        base: '!border-0 hover:border-0'
      }
    }
  },
  compoundVariants: [
    {
      loading: false,
      disabled: false,
      color: 'primary',
      class: 'hover:bg-bg-items-black hover:text-text-main-inversion'
    },
    {
      loading: false,
      disabled: false,
      color: 'secondary',
      class: 'hover:bg-button-hover'
    },
    {
      loading: false,
      disabled: false,
      color: 'white',
      class:
        'hover:bg-button-main-inversion hover:border-button-inactive hover:text-button-inactive'
    },
    {
      disabled: true,
      color: ['primary']
      // class: 'border-button-inactive text-text-inactive'
    },
    {
      disabled: true,
      color: ['secondary'],
      class:
        'hover:bg-system-gray-300 bg-system-gray-300 text-text-inactive cursor-default border-transparent'
    },
    {
      disabled: true,
      color: ['white'],
      class:
        'bg-button-main-inversion border-button-inactive text-text-inactive'
    }
  ],
  defaultVariants: {
    size: 'base',
    color: 'primary',
    loading: false,
    disabled: false
  }
});
